__turbopack_context__.v({
  "productImage": "TechSpecComponent-module__qzyllq__productImage",
  "sectionTitle": "TechSpecComponent-module__qzyllq__sectionTitle",
  "specLabel": "TechSpecComponent-module__qzyllq__specLabel",
  "specRow": "TechSpecComponent-module__qzyllq__specRow",
  "specTable": "TechSpecComponent-module__qzyllq__specTable",
  "specValue": "TechSpecComponent-module__qzyllq__specValue",
  "specificationSection": "TechSpecComponent-module__qzyllq__specificationSection",
  "techContainer": "TechSpecComponent-module__qzyllq__techContainer",
  "title": "TechSpecComponent-module__qzyllq__title",
});
